import * as React from 'react';
import cn from 'clsx';

import * as styles from './arrow.css';

import { trackArrowClick } from '../../../tracking';
import arrow from './icon/arrow.svg';

interface IProps {
  className?: string;
  style?: object;
  rotated?: boolean;
  slideCount?: number;
  currentSlide?: number;
  onClick?(): void;
}

function handleClickWithAnalytics(cb: (() => void) | undefined) {
  if (cb) {
    cb();
  }

  trackArrowClick();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Arrow: React.FC<IProps> = ({ className, rotated, style, slideCount, currentSlide, onClick, ...rest }) => {
  return (
    <div className={cn(styles['arrow'], className)} onClick={() => handleClickWithAnalytics(onClick)} {...rest}>
      <img className={cn(rotated && styles['rotate'])} src={arrow} alt="" />
    </div>
  );
};
